export default "__VITE_ASSET__Cw$hKhNs__"